import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledSection = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 clamp(28px, 6vw, 80px) 150px;

  .wrap {
    padding: 46px 34px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.42);
    border: 1px solid rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(22px);
    text-align: center;
  }

  .eyebrow {
    margin: 0 0 12px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 12px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .title {
    margin: 0;
    color: var(--text-primary);
    font-size: clamp(36px, 4.8vw, 62px);
    line-height: 1.06;
    letter-spacing: -0.05em;
  }

  .row {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 28px;
  }

  .primaryBtn,
  .secondaryBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 50px;
    padding: 0 22px;
    border-radius: 999px;
    text-decoration: none;
    font-size: 13px;
    font-family: var(--font-mono);
  }

  .primaryBtn {
    color: #fff;
    background: #111;
    border: 1px solid #111;
  }

  .secondaryBtn {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.58);
    border: 1px solid var(--border-light);
  }
`;

const CTA = () => (
  <StyledSection>
    <div className="wrap">
      <p className="eyebrow">Contact</p>
      <h2 className="title">Open to meaningful collaboration.</h2>

      <div className="row">
        <Link className="primaryBtn" to="/contact">
          Get in touch
        </Link>
        <Link className="secondaryBtn" to="/projects">
          View work
        </Link>
      </div>
    </div>
  </StyledSection>
);

export default CTA;